import { TieupRankingGetInputModel } from "./GetInputModel"
import { GetTieupRankingResponse } from "./getResponse"
import { httpGet } from "../../../../libs/http/httpGet"

const endpointUrl = "/v1/tieup/ranking"

export const callGetTieupRanking = async (model: TieupRankingGetInputModel) => {
  return httpGet<GetTieupRankingResponse>(endpointUrl, model)
}
